exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter {\n  margin-top: 16px;\n  margin-left: auto;\n  font-size: 14px;\n  text-align: center;\n  padding-top: 10px;\n  height: 40px;\n  width: 80px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: aliceblue;\n  font-weight: 900; }\n\n.export-btn {\n  padding-top: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/plan-process/plan-process.scss
// module id = ../../../../../src/app/pages/plan-process/plan-process.scss
// module chunks = 39